import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { ThemeProvider } from './contexts/ThemeContext'
import { NotificationProvider } from './contexts/NotificationContext'
import { AccessibleLayout } from './components/accessibility/AccessibleLayout'
// Import local MainLayout with ClientSelector
import { MainLayout } from './components/layout/MainLayout'
// Use local ProtectedRoute that uses the partner-admin authStore
import ProtectedRoute from './components/auth/ProtectedRoute'
import Login from './pages/Login'
import { PartnerDashboard } from './pages/PartnerDashboard'
import { ClientManagement } from './pages/ClientManagement'
import { TaxManagement } from './pages/TaxManagement'
// Pós-MVP: Processamento de Documentos - não há fluxo de aprovação implementado
// import { DocumentManagement } from './pages/DocumentManagement'
// Pós-MVP: Relatórios Avançados - schema do banco incompatível, ver POS-MVP.md
// import { Reports } from './pages/Reports'
import { Analytics } from './pages/Analytics'
import { Support } from './pages/Support'
import { PartnerSettings } from './pages/Settings'
// import { Accountants } from './pages/Accountants' // Removido - funcionalidade integrada em Clientes
import { Whitelabel } from './pages/Whitelabel'
import { TeamManagement } from './pages/TeamManagement'
import { NotificationTesting } from './pages/NotificationTesting'
// Pós-MVP: Webhooks - funcionalidade avançada de integração
// import { Webhooks } from './pages/Webhooks'

function App() {
  return (
    <div data-theme="partner" className="min-h-screen">
      <ThemeProvider>
        <NotificationProvider>
          <AccessibleLayout>
            <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
            <Routes>
            {/* Public route */}
            <Route path="/login" element={<Login />} />

            {/* Protected routes */}
            <Route element={<ProtectedRoute />}>
              <Route element={<MainLayout />}>
                <Route path="/" element={<Navigate to="/dashboard" replace />} />
                <Route path="/dashboard" element={<PartnerDashboard />} />
                <Route path="/clients" element={<ClientManagement />} />
                {/* <Route path="/accountants" element={<Accountants />} /> */}
                <Route path="/tax-management" element={<TaxManagement />} />
                {/* Pós-MVP: Processamento de Documentos */}
                {/* <Route path="/documents" element={<DocumentManagement />} /> */}
                {/* Pós-MVP: Relatórios Avançados */}
                {/* <Route path="/reports" element={<Reports />} /> */}
                <Route path="/analytics" element={<Analytics />} />
                <Route path="/support" element={<Support />} />
                <Route path="/whitelabel" element={<Whitelabel />} />
                <Route path="/team" element={<TeamManagement />} />
                {/* Pós-MVP: Webhooks */}
                {/* <Route path="/webhooks" element={<Webhooks />} /> */}
                <Route path="/settings" element={<PartnerSettings />} />
                <Route path="/notifications-test" element={<NotificationTesting />} />
              </Route>
            </Route>
            </Routes>
            </BrowserRouter>
          </AccessibleLayout>
        </NotificationProvider>
      </ThemeProvider>
    </div>
  )
}

export default App
